import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'

const pushPreGameMetric = async (gametype, action, label) => {
  const userInfo = getUserInfo()
  if (!userInfo) {
    return false
  }

  const category = {
    snake: 'Planeta_Menstruacion',
    tetris: 'Planeta_Pubertad',
    linea3: 'Planeta_ZonaV',
  }[gametype]
  pushEventData({
    event: 'Interacciones_prejuego_UCole',
    category,
    action,
    label,
    user_data: [
      await jsonToHash({
        nombre: userInfo.name,
        apellido: userInfo.lastName,
        celular: userInfo.cellPhone,
        correo: userInfo.email,
        ciudad: userInfo.location.cityName,
        departamento: userInfo.location.countryStateName,
        pais: userInfo.countryName,
      }),
    ],
    log_status: 'Yes',
  })
  return true
}

export default pushPreGameMetric
